module.exports = __webpack_public_path__ + "img/shijie.0c5e52bc.png";